import React from "react";


const Items = (props) => {

    return (
        <div className="flex flex-col justify-center items-center text-white w-full h-[40%]">
            <div className="flex flex-row-reverse justify-center items-center w-full h-full" style={{fontSize:(props["font_size"])}}>
                <span className={`w-[8%] py-[4%] bg-[${props["color"]}] ml-2 relative top-[-14%] rounded-sm`}></span>
                {props["title"]}
            </div>
            <div className="flex justify-center items-center w-full h-full" style={{fontSize:(props["font_size_number"])}}>
                {parseInt(props["amount"]).toLocaleString()}
            </div>
        </div>
    );
};

export default Items;